import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from '../services/Session';
import { SwitchBoard } from '../services/SwitchBoard';
import { LoadingService } from '../services/LoadingService';
import { TaxPlanningService } from '../tpiq-services/tax-planning.service';
import {TOAST_TYPE} from '../constants/Tpiq.constants';
import {ToastService} from '../services/Toast.service';

@Component({
  selector: 'app-manage-user-billing',
  templateUrl: './manage-user-billing.html'
})

export class ManageUserBillingComponent implements OnInit, OnDestroy {
  user: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  portalUrl: any;

  constructor(
    private _router: Router,
    private switchBoard: SwitchBoard,
    private loadingService: LoadingService,
    private taxPlanningService: TaxPlanningService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
  }

  openManageBillingWidget(){
    this.getStripePortalLink();
  }

  getStripePortalLink(){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getUserSingleSignOnInfo(Session.getOrg(), this.user.id, {})
      .subscribe(response => {
        if (response && response.portalUrl) {
           if(response && response.portalUrl){
            const url = response.portalUrl;
            const windowName = '_blank';
            window.open(url, windowName);
          }
        }
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to perform operation');
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}